'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _templateObject = (0, _taggedTemplateLiteral3.default)([''], ['']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n            Expected `StepContent` or `StepActions` \n            but found `', '`\n          '], ['\n            Expected \\`StepContent\\` or \\`StepActions\\` \n            but found \\`', '\\`\n          ']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _step_label = require('./step_label');

var _step_label2 = _interopRequireDefault(_step_label);

var _step_title = require('./step_title');

var _step_title2 = _interopRequireDefault(_step_title);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _step_content = require('./step_content');

var _step_content2 = _interopRequireDefault(_step_content);

var _step_actions = require('./step_actions');

var _step_actions2 = _interopRequireDefault(_step_actions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Step = function (_React$Component) {
  (0, _inherits3.default)(Step, _React$Component);

  function Step(props) {
    (0, _classCallCheck3.default)(this, Step);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(Step).call(this, props));

    _this.state = {
      completed: false,
      skipped: false
    };

    _this.completeStep = _this.completeStep.bind(_this);
    _this.skipStep = _this.skipStep.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(Step, [{
    key: 'getChildren',
    value: function getChildren() {
      var _props = this.props;
      var children = _props.children;
      var isLastChild = _props.isLastChild;


      return _react2.default.Children.map(children, function (child) {
        var ref = void 0;
        if (child.type === _step_content2.default) {
          ref = 'stepContent';
        } else if (child.type === _step_actions2.default) {
          ref = 'stepActions';
        }
        return (0, _react.cloneElement)(child, { ref: ref, isLastChild: isLastChild });
      });
    }
  }, {
    key: 'getMessage',
    value: function getMessage() {
      var _props2 = this.props;
      var summary = _props2.summary;
      var completedSummary = _props2.completedSummary;
      var skippedSummary = _props2.skippedSummary;

      var message = summary;
      if (completedSummary && this.state.completed) {
        message = completedSummary;
      } else if (skippedSummary && this.state.skipped) {
        message = skippedSummary;
      }

      return message;
    }

    // componentDidUpdate(prevProps, prevState) {
    //   const { isActive } = this.props;
    //
    //   if (isActive) {
    //     const { stepContent, stepLabel } = this.refs;
    //     stepLabel.setContentHeight(
    //       stepContent.getDimensions().height
    //     );
    //   }
    //
    // }

  }, {
    key: 'classNames',
    value: function classNames() {
      return (0, _classnames2.default)('mdl-step', {
        'mdl-step--editable': this.props.editable,
        'mdl-step--optional': this.props.optional,
        'mdl-step--completed': this.state.completed,
        'is-active': this.props.isActive
      });
    }
  }, {
    key: 'completeStep',
    value: function completeStep() {
      this.setState({ completed: true });
      this.props.onNext();
    }
  }, {
    key: 'skipStep',
    value: function skipStep() {
      this.setState({ skipped: true });
      this.props.onNext();
    }
  }, {
    key: 'handleClick',
    value: function handleClick(event) {
      var _props3 = this.props;
      var isActive = _props3.isActive;
      var editable = _props3.editable;
      var count = _props3.count;
      var setStep = _props3.setStep;

      if (!isActive && editable) {
        event.preventDefault();

        /* return to this editable step */
        setStep(count);
      } else if (event.target.dataset.stepperNext) {
        event.preventDefault();

        this.completeStep();
      } else if (event.target.dataset.stepperSkip) {
        event.preventDefault();

        this.skipStep();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props4 = this.props;
      var title = _props4.title;
      var count = _props4.count;

      return _react2.default.createElement(
        'li',
        { className: this.classNames(), onClick: this.handleClick.bind(this) },
        _react2.default.createElement(
          _step_label2.default,
          (0, _extends3.default)({
            ref: 'stepLabel',
            stepNumber: count
          }, this.props, {
            completed: this.state.completed
          }),
          _react2.default.createElement(_step_title2.default, { text: title, message: this.getMessage() })
        ),
        this.getChildren()
      );
    }
  }]);
  return Step;
}(_react2.default.Component);

Step.propTypes = {
  isLastChild: _react.PropTypes.bool,
  editable: _react.PropTypes.bool,
  optional: _react.PropTypes.bool,
  title: _react.PropTypes.string.isRequired,
  summary: _react.PropTypes.string,
  completedSummary: _react.PropTypes.string,
  skippedSummary: _react.PropTypes.string,
  count: _react.PropTypes.number,
  isActive: _react.PropTypes.bool,
  setStep: _react.PropTypes.func,
  onNext: _react.PropTypes.func.isRequired,
  children: function children(props, propName) {
    var children = props[propName];

    _react2.default.Children.forEach(children, function (child) {
      if (child.type !== _step_actions2.default || child.type !== _step_content2.default) {
        throw new Error(''(_templateObject2, child.type.displayName || child.type)(_templateObject));
      }
      return;
    });
  }
};

exports.default = Step;


//////////////////
// WEBPACK FOOTER
// ./~/react-mdl-stepper/dist/step.js
// module id = 356
// module chunks = 0